import { Api } from "../Api";
import { ISpecies } from "../models/ISpecies";

class SpeciesApi {
  static list(signal?: AbortSignal): Promise<ISpecies[]> {
    return Api.Get<ISpecies[]>("api/species", signal);
  }

  static get(uuid: string, signal?: AbortSignal): Promise<ISpecies> {
    return Api.Get<ISpecies>(`api/species/${uuid}`, signal);
  }

  static create(species: ISpecies, signal?: AbortSignal): Promise<ISpecies> {
    return Api.Post<ISpecies>(`api/species`, species, signal);
  }

  static update(species: ISpecies, signal?: AbortSignal): Promise<ISpecies> {
    return Api.Put<ISpecies>(`api/species/${species.uuid}`, species, signal);
  }

  static delete(uuid: string, signal?: AbortSignal): Promise<ISpecies> {
    return Api.Delete<ISpecies>(`api/species/${uuid}`, signal);
  }
}

export { SpeciesApi }
